import { cva, VariantProps } from "class-variance-authority";

const blockElements = [
  "div",
  "p",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "section",
  "article",
  "aside",
  "header",
  "footer",
  "nav",
  "figure",
  "figcaption",
  "blockquote",
  "pre",
  "ol",
  "ul",
  "li",
  "main",
  "table",
  "thead",
  "tbody",
  "tfoot",
  "tr",
  "th",
  "td",
  "form",
  "fieldset",
  "legend",
  "address",
  "details",
  "summary",
  "canvas",
  "output",
  "video",
  "audio",
] as const;

const inlineElements = [
  "span",
  "a",
  "strong",
  "em",
  "abbr",
  "cite",
  "code",
  "b",
  "i",
  "sub",
  "sup",
  "mark",
  "q",
  "time",
  "var",
  "s",
  "u",
  "small",
  "br",
  "wbr",
  "data",
  "label",
  "kbd",
  "bdo",
  "bdi",
] as const;

export const textVariants = cva("", {
  variants: {
    spacing: {
      4: "tw-gap-4",
      6: "tw-gap-6",
      8: "tw-gap-8",
      12: "tw-gap-12",
      16: "tw-gap-16",
      20: "tw-gap-20",
      24: "tw-gap-24",
      28: "tw-gap-28",
      32: "tw-gap-32",
    },
    prefix: {
      true: "",
      false: "",
    },
    suffix: {
      true: "",
      false: "",
    },
    element: [...blockElements, ...inlineElements].reduce(
      (acc, element) => ({
        ...acc,
        [element]: "",
      }),
      {},
    ) as Record<ElementType, string>,
  },
  compoundVariants: [
    {
      element: inlineElements as unknown as ElementType[],
      class: "tw-inline-block", // this forces line height to be respected
    },
    {
      element: inlineElements as unknown as ElementType[],
      prefix: true,
      class: "tw-inline-flex tw-items-center",
    },
    {
      element: inlineElements as unknown as ElementType[],
      suffix: true,
      class: "tw-inline-flex tw-items-center",
    },
    {
      element: blockElements as unknown as ElementType[],
      prefix: true,
      class: "tw-flex tw-items-center",
    },
    {
      element: blockElements as unknown as ElementType[],
      suffix: true,
      class: "tw-flex tw-items-center",
    },
  ],
});

export type ElementType = (
  | typeof blockElements
  | typeof inlineElements
)[number];
export type TextVariantProps = VariantProps<typeof textVariants>;
